import { Analytics } from '@vercel/analytics/react';
import TradingJournal from './TradingJournal';
import { DataPersistenceProvider } from './context/DataPersistenceContext';
import './App.css';

function App() {
  return (
    <DataPersistenceProvider>
      <div className="App">
        <TradingJournal />
      </div>
      <Analytics />
    </DataPersistenceProvider>
  );
}

export default App;
